import React from 'react';
import './HeroSection.scss';

// Default placeholder image for properties
const DEFAULT_COVER_IMAGE = 'https://cdn.pixabay.com/photo/2016/06/24/10/47/house-1477041_1280.jpg';

interface HeroSectionProps {
  imageUrl?: string;
  title: string;
  subtitle?: string;
  height?: 'small' | 'medium' | 'large';
  showGradient?: boolean;
  children?: React.ReactNode;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  imageUrl,
  title,
  subtitle,
  height = 'medium',
  showGradient = true,
  children,
}) => {
  const backgroundImage = imageUrl || DEFAULT_COVER_IMAGE;

  return (
    <div className={`hero-section hero-section--${height}`}>
      <div
        className="hero-section__image"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      {showGradient && <div className="hero-section__gradient" />}

      <div className="hero-section__content">
        <h1 className="hero-section__title">{title}</h1>
        {subtitle && <p className="hero-section__subtitle">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
};

export default HeroSection;
